// extracted by mini-css-extract-plugin
export default {"backButton":"UKogqYkaTwHrS1q8m445","buttonContainer":"J6n7HkAl6VSW4zoZO42g","input":"SG3MRdOjGKLzIW61zFxD","saveContainer":"_3fcLHHFAsp4wE06tPKC"};